import * as zod from 'zod';

export const CNCMonitorMachineVariables = zod.object({});

export type CNCMonitorMachineVariables = zod.infer<
  typeof CNCMonitorMachineVariables
>;
